// extracted by mini-css-extract-plugin
export default {"risk-count":"S1bN1mwlnzLVQDzTwMVf"};